"use strict";

define('components/filter_bar/table/result_counts',[], function() {
    var resultCountsComponent = {
        initWithContext: function(context) {
            var tableContainer = context.tableFilterBarData.tableContainer;
            var resultCountsNode = context.buttonbarNode.find('.buttonbar-result-counts');

            resultCountsNode.on('click', '.expand-all-regions > a', function(e) {
                var toggler =  $(e.target);
                var expandos = tableContainer.find('tr.subheading.expando');

                context.tableFilterBarData.expandedRegions = [];
                
                if (toggler.data('expanded')) {
                    expandos.filter('.expando-expanded')
                            .click();

                    var newContent = toggler.html().replace(/Collapse/, 'Expand');
                    toggler.html(newContent);
                    toggler.data('expanded', false);
                } else {
                    expandos.each(function() {
                        var region = $(this).data('region');
                        if (region) {
                            context.tableFilterBarData.expandedRegions.push(region);
                        }
                    });

                    expandos.filter('.expando-collapsed')
                            .click();

                    var newContent = toggler.html().replace(/Expand/, 'Collapse');
                    toggler.html(newContent);
                    toggler.data('expanded', true);
                }
            });

            resultCountsNode.on('click', 'a.clear-filters', function(e) {
                var clearLink = $(e.target);

                e.preventDefault();
                e.stopPropagation();

                context.buttonbarNode.trigger('jsq:resultCountsClickedClearFilters', {
                    url: clearLink.attr('href')
                });
            });
        }
    };

    return resultCountsComponent;
});
